/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cancellation_DeadlineInputs */

const en_cancellation_deadline = /** @type {(inputs: Cancellation_DeadlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Full refund until ${i?.date}, less the payment provider's fee.`)
};

/**
* | output |
* | --- |
* | "Full refund until {date}, less the payment provider's fee." |
*
* @param {Cancellation_DeadlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cancellation_deadline = /** @type {((inputs: Cancellation_DeadlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancellation_DeadlineInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cancellation_deadline(inputs)
});